<template>
  <!-- 列表 组件 -->
  <div class="contentList_component" v-loading="list == ''">
    <!-- <ul :style="{padding:paddingIsShow=='true'?' 0 40px':' 0 0'}" > -->
    <ul v-show="list">
      <li v-for="(item,index) in newlist" :key="index">
        <!-- <div
          class="selects"
          v-if="selShow"
          @click="selectsfun(item,index)"
          :style="{borderColor:item.statePlus?'rgba(21, 47, 106, 1)':'rgba(204,204,204,1)',backgroundColor:item.statePlus?'rgba(21, 47, 106, 1)':''}"
        >
          <img src="@/assets/duiHao.png" alt />
        </div>-->
        <div>
          <div @click="goRouter(item,index)">
            <h3 class="topTitle">{{ item.Title | ellipsis}}</h3>
            <div class="centerContent">
              <div
                class="centerContent_subLeft_content"
                :style="{width:item.HasImg?contentWidth:notimg+'px'}"
              >
                <p>
                  <span v-html="item.Summary"></span>
                  <span style="color:#175199;">...阅读全文</span>
                </p>
              </div>
              <div class="centerContent_subLeft_img" v-show="item.HasImg">
                <img v-lazy="item.CoverImg" />
              </div>
            </div>
          </div>
          <div class="footerContent">
            <div class="f_cont_left">
              <span>{{ item.MagazineName }}</span>
              <span>{{ `${ item.Year }年第${ item.Issue }期` }}</span>
              <span>栏目</span>
              |
              <span>{{ item.Columns }}</span>
              <span>{{ item.Author }}</span>
            </div>
            <div class="f_cont_right">
              <div class="fContRight_sub_zan" @click="fContRight_sub_zan(index,item)">
                <img v-show="item.is_follow==1" src="@/assets/zanFalse.png" alt />
                <img v-show="item.is_follow==2" src="@/assets/zanTrue.png" alt />
                <span>{{ item.follow_nums || 0 }}</span>
              </div>
              <div v-if="item.is_auth == 3" class="addclub" @click="joinAuthorization(item,index)">加入授权</div>
              <div v-if="item.is_auth == 1" class="addclub2" @click="joinAuthorization(item,index)">已加入</div>
              <div v-if="item.is_auth == 2" class="addclub" @click="joinAuthorization(item,index)">再次授权</div>
            </div>
          </div>
          <div class="li_bottomBorder"></div>
        </div>
      </li>
    </ul>
    <div class="contentListImg" v-show="list.length==0 && routePath">
      <img src="@/assets/conmiss.jpg" alt />
    </div>
  </div>
</template>

<script>
import { getToken } from "../../../../static/js/util.js";

import { followArticle } from "@/api/lxc";
import { addArticlemth } from "@/api/lyl";

// 相关推荐 w:1020
// 个人中心 w:630
// 高级搜索 w:620
//频道列表 w:620
//搜索结果 w:620
export default {
  name: "contentList_component",
  props: {
    contentWidth: {
      default: "620px"
    },
    selectAll: {
      type: null
    },
    paddingIsShow: {
      default: "true"
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    addCallBack: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      notimg: "725",
      newarrlist: [],
      selShow: "true",
      arr: [],
      selects: false,
      routePath: false
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 35) {
        return (value.slice(0, 35) + '...').trim();
      }
      return value.trim();
    }
  },
  computed: {
    newlist() {
      let newarr = this.list.map((item, index) => {
        item.statePlus = false;
        return item;
      });
      console.log(newarr);
      return newarr;
    }
  },
  watch: {
    selectAll(n) {
      this.newarrlist = [];
      if (n == 1) {
        this.newlist.map((item, index) => {
          this.$forceUpdate();
          item.statePlus = true;
          this.newarrlist.push(item.docid);
        });
      } else if (n == 0) {
        this.newarrlist = [];
        this.newlist.map((item, index) => {
          this.$forceUpdate();
          item.statePlus = false;
        });
      } else {
      }
      console.log(this.newarrlist);
    }
    // $route(e) {
    //   alert(e);
    //   if (e.name != "searchResult") {
    //     this.search_val = "";
    //   }
    // }
  },
  methods: {
    async joinAuthorization(v, i) {
      console.log(v);
      if (this.$store.state.userInfo.unique_code) {
        try {
          const data = await addArticlemth({
            user_unique_code: getToken("unique_code"),
            title_id: v.TitleID,
            title: v.Title,
            origin: v.MagazineName+v.Year+"年"+v.Issue+'期',
            usage_mode: "转载使用",
            admin_code: this.$store.state.userInfo.admin_code
          });
          // console.log(data)
          this.$message("授权成功");
          // this.$store.state.artlisttype ++
          const abc = this.$store.state.artlisttype+1
          this.$store.commit("setimgstoy",abc)
          console.log(this.addCallBack)
          if(this.addCallBack){
            this.addCallBack()
          }
        } catch (err) {
          console.log(err);
          this.$message(err.message);
        }
      } else {
        this.$message.warning("请先登录");
        this.$router.push({ path: "/login" });
      }
    },

    selectsfun(res, index) {
      this.$emit("dotsel", {
        data: "3"
      });
      this.newlist[index].statePlus = !res.statePlus;
      this.$forceUpdate();
      this.newarrlist = [];
      this.newlist.map((item, index) => {
        if (item.statePlus) {
          this.newarrlist.push(item.docid);
        }
      });
      console.log(this.newarrlist);
    },

    fContRight_sub_zan(index, item) {
      console.log(item);
      if (this.$store.state.userInfo.unique_code) {
        this.followArticleFn(item, index);
      } else {
        this.$message.warning("请先登录");
        this.$router.push({ path: "/login" });
      }
    },
    goRouter(v, i) {
      let a = location.origin + "/articledetails?initialState=" + v.TitleID;
      window.open(a);
      // http://192.168.1.14:8092/#/articledetails?initialState=hqrw20192216
      // this.$router.push({
      //   path: "/articledetails",
      //   query: { initialState: v.TitleID }
      // });
    },
    async followArticleFn(item, index) {
      let needindex = index;
      console.log(item.is_follow, needindex);
      try {
        const data = await followArticle({
          TitleID: item.TitleID,
          follow_nums: item.follow_nums ? item.follow_nums : "0",
          docid: item.docid,
          uid: this.$store.state.userInfo.unique_code,
          follow_type: item.is_follow == 1 ? "1" : "2"
        });
        //切换收藏显示状态
        //  console.log(index)
        this.list[index].is_follow = Number(item.is_follow) == 1 ? 2 : 1;
        //  console.log(this.list[index].is_follow)
        if (item.is_follow == 1) {
          this.list[index].follow_nums =
            Number(this.list[index].follow_nums) - 1;
        } else {
          this.list[index].follow_nums =
            Number(this.list[index].follow_nums) + 1;
        }
      } catch (err) {}
    }
  },
  mounted() {
    let routePath = this.$route.path;
    if (routePath === "/personalCenter/collection") {
      this.selShow = false;
    }

    if (routePath === "/articledetails") {
      this.selShow = false;
      this.notimg = 1120;
    }

    if (routePath === "/articledetails") {
      this.routePath = false;
    }
  }
};
</script>

<style scoped lang="less">
.addclub {
  width: 68px;
  background: rgba(21, 47, 106, 1);
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  text-align: center;
  margin-left: 20px;
}
.addclub2 {
  background: rgba(179, 179, 179, 1);
  width: 68px;
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  text-align: center;
  margin-left: 20px;
}
.contentList_component li:hover {
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.2);
}
.contentList_component {
  cursor: pointer;
  ul {
    // padding: 0 40px;
    li {
      position: relative;
      padding: 20px;
      display: flex;
      justify-content: center;
      .selects {
        width: 18px;
        height: 18px;
        transition: 0.2s;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(204, 204, 204, 1);
        img {
          height: 12px;
        }
      }
      .li_bottomBorder {
        height: 1px;
        width: 90%;
        background: #f3f3f3;
        position: absolute;
        bottom: 0;
      }
      .topTitle {
        font-size: 20px;
        cursor: pointer;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        height: 20px;
        line-height: 20px;
        // padding:0 0 20px 0;
      }
      .centerContent {
        font-size: 14px;
        // font-weight:600;
        color: rgba(150, 150, 150, 1);
        line-height: 20px;
        padding: 20px 0 10px 0;
        display: flex;
        justify-content: space-between;
        .centerContent_subLeft_content {
          text-align: justify;
          display: inline-flex;
          justify-content: space-between;
          p {
            color: #696969;
          }
        }
        .centerContent_subLeft_img {
          width: 80px;
          height: 80px;
          cursor: pointer;
          // background: rgba(179, 179, 179, 1);
          border-radius: 6px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 20px;
          img {
            // width: 100%;
            // height: 100%;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
      .footerContent {
        display: flex;
        justify-content: space-between;
        .f_cont_left {
          height: 2px;
          font-size: 12px;
          //   font-weight: 500;
          color: #bebebe;
          line-height: 20px;
        }
        .f_cont_right {
          font-size: 12px;
          font-weight: 500;
          color: rgba(150, 150, 150, 1);
          line-height: 24px;
          display: flex;
          .fContRight_sub_zan {
            // padding-right: 48px;
            cursor: pointer;
            display: flex;
            align-items: center;
            img {
              width: 24px;
              height: 24px;
            }
          }
        }
      }
    }
  }
  .contentListImg {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/contentList/index.vue